var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAZ(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_291_387)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.0999 26.5996H26.4099L37.6199 10.6396C37.9999 10.0696 37.9999 9.30961 37.8099 8.73961C37.4299 7.97961 36.8599 7.59961 36.0999 7.59961H22.7999C21.6599 7.59961 20.8999 8.35961 20.8999 9.49961C20.8999 10.6396 21.6599 11.3996 22.7999 11.3996H32.4899L21.2799 27.3596C20.8999 27.9296 20.8999 28.6896 21.0899 29.2596C21.4699 29.8296 22.0399 30.2096 22.7999 30.2096H36.0999C37.2399 30.2096 37.9999 29.4496 37.9999 28.3096C37.9999 27.3596 37.2399 26.5996 36.0999 26.5996Z",
    fill: "white",
    fillOpacity: 0.73
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4899 24.6996L15.1999 29.2596C15.9599 30.7796 17.4799 30.3996 17.6699 30.3996C18.6199 30.0196 19.1899 28.8796 18.8099 27.9296L11.2099 8.92961C11.0199 8.16961 10.2599 7.59961 9.49986 7.59961C8.73986 7.59961 7.97986 8.16961 7.78986 8.73961L2.46986 22.0396L0.189863 27.7396C-0.190137 28.6896 0.189863 29.8296 1.32986 30.2096C2.27986 30.5896 3.41986 30.2096 3.79986 29.0696L5.50986 24.6996H13.4899ZM9.49986 14.6296L11.9699 20.8996H7.02986L9.49986 14.6296Z",
    fill: "white",
    fillOpacity: 0.73
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9997 0L15.1997 5.7H22.7997L18.9997 0Z",
    fill: "white",
    fillOpacity: 0.73
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9997 37.9998L22.7997 32.2998H15.1997L18.9997 37.9998Z",
    fill: "white",
    fillOpacity: 0.73
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_291_387"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAZ);
export default __webpack_public_path__ + "static/media/a-z.93a4a645db78979702c193a99e890672.svg";
export { ForwardRef as ReactComponent };